export const setConfigs = (state, payload) => state.configs = payload;

export const setSealConfigs = (state, payload) => state.sealConfigs = payload;
